import React from 'react'
import { Route, Switch } from 'react-router-dom'

import {
  OrderListPage,
  OrderPage,
  // PickingPage,
  ReplenishmentListPage,
  ShipmentListPage,
  ShipmentPage,
  TruckloadListPage,
  TruckloadPage,
} from './pages/freight'

export const FreightRouter = () => {
  return (
    <Switch>
      <Route path='/freight/orders/:guid' component={OrderPage} exact />
      <Route path='/freight/orders' component={OrderListPage} exact />
      <Route path='/freight/replenishment' component={ReplenishmentListPage} exact />
      <Route path='/freight/shipments/:guid' component={ShipmentPage} exact />
      <Route path='/freight/shipments' component={ShipmentListPage} exact />
      <Route path='/freight/truckloads/:guid' component={TruckloadPage} exact />
      <Route path='/freight/truckloads' component={TruckloadListPage} exact />
    </Switch>
  )
}
